import axios from 'axios';

const BASE_URL = process.env.REACT_APP_WC_URL || 'https://tuosito.com/wp-json/wc/v3';
const WC_KEY = process.env.REACT_APP_WC_KEY || 'ck_d0f731f32afec7f7e320c262e6ae0a74acd3f2d5';
const WC_SECRET = process.env.REACT_APP_WC_SECRET || 'cs_77bfb544c7a38ae89edf8f482ab6c20fa1c52ce2';

const auth = {
  username: WC_KEY,
  password: WC_SECRET,
};

// Mappa nomi categorie Figma -> slug WooCommerce
export const CATEGORY_MAP = {
  'Bolognesi': 'bolognesi',
  'Surf Casting': 'surf-casting',
  'Spinning': 'spinning',
  'Eging': 'eging',
  'Slow Pitch': 'slow-pitch',
  'Boat & Trolling': 'boat-trolling',
  'Line': 'line',
  'Tools': 'tools',
};

export const NAV_CATEGORIES = [
  'Bolognesi',
  'Surf Casting',
  'Spinning',
  'Eging',
  'Slow Pitch',
  'Boat & Trolling',
  'Line',
  'Tools',
];

// Ottieni tutte le categorie prodotti
export const getCategories = async () => {
  const res = await axios.get(`${BASE_URL}/products/categories`, {
    auth,
    params: { per_page: 50 },
  });
  return res.data;
};

// Ottieni prodotti con filtri opzionali
export const getProducts = async ({ category, perPage = 12, page = 1, search } = {}) => {
  const params = { per_page: perPage, page };
  if (category) params.category = category;
  if (search) params.search = search;
  const res = await axios.get(`${BASE_URL}/products`, { auth, params });
  return res.data;
};

// Ottieni singolo prodotto per ID
export const getProduct = async (id) => {
  const res = await axios.get(`${BASE_URL}/products/${id}`, { auth });
  return res.data;
};

// Ottieni singolo prodotto per slug
export const getProductBySlug = async (slug) => {
  const res = await axios.get(`${BASE_URL}/products`, { auth, params: { slug } });
  return res.data[0] || null;
};

// Ottieni prodotti correlati
export const getRelatedProducts = async (ids) => {
  if (!ids || ids.length === 0) return [];
  const params = { include: ids.join(','), per_page: 4 };
  const res = await axios.get(`${BASE_URL}/products`, { auth, params });
  return res.data;
};

// Ottieni varianti di un prodotto variabile
export const getProductVariations = async (id) => {
  const res = await axios.get(`${BASE_URL}/products/${id}/variations`, {
    auth,
    params: { per_page: 100 },
  });
  return res.data;
};

// Ottieni ID categoria da slug
export const getCategoryIdBySlug = async (slug) => {
  const res = await axios.get(`${BASE_URL}/products/categories`, {
    auth,
    params: { slug },
  });
  return res.data[0]?.id || null;
};
